<!-- <p>calendar-date works!</p> -->
<div class="visitor-calendar" (click)="calendarToggle()">
  <mat-card class="visitor-calendar-card">
    <mat-calendar
      #calendar
      [headerComponent]="exampleHeader"
      [(selected)]="date"
      [minDate]="minDate"
    ></mat-calendar>
  </mat-card>
</div>
